import * as React from 'react';
import { withStyles, WithStyles, } from '@material-ui/core';
import clsx from 'clsx';
import Style from './style';
import { CircularProgress } from '..';

interface Props extends WithStyles<typeof Style>, React.HTMLAttributes<HTMLDivElement> {
	// pass
	loading: boolean;
}
/**
 *
 */
class LoadingButton extends React.PureComponent<Props> {
	/**
	 * Render method
	 * @returns {JSX.Element} Jsx.
	 */
	public render() {
		const { classes, children, loading, className, ...rest } = this.props;
		return (
			<div className={clsx(classes.root, className)} {...rest}>
				{children}
				{loading && <CircularProgress size={24} className={classes.buttonProgress} />}
			</div>
		);
	}
}

export default withStyles(Style, { name: 'DP-LoadingButton' })(LoadingButton);
